<template>
  <div class="report-wrap">
    <div class="report-item report-item_admin" @click="onClick">
      <v-row no-gutters>
        <v-col sm="2" lg="2" cols="12" class="report-item__text report-item__text_bold">
          {{user.employee.email}}
        </v-col>
        <v-col sm="2" lg="2" cols="12" class="report-item__text pl-5">
          {{fullName}}
        </v-col>
        <v-col sm="3" lg="4" cols="12" class="report-item__text pl-5 pr-5">
          <div>{{user.company.fullName}}</div>
          <div class="report-item__text_color">ИНН: {{user.company.inn}}</div>
        </v-col>
        <v-col sm="3" lg="2" cols="12" class="report-item__text report-item__last pr-5">
          <v-switch
            v-model="status"
            :label="user.company.status==='active' ? 'Активный' : 'Неактивный'"
            :color="'green'"
            :class="'switch-visible'"
            hide-details
            class="admin-form-base__check-line user-status-sh"
            @click.stop.prevent="changeStatus"
            inset></v-switch>


          <v-btn text icon class="ml-1 btn-delete"
                 v-if="user.company.status!=='active'"
                 @click.stop.prevent="remove(user.company.id)">
            <v-icon size="25" color="green">{{ mdiWindowClose }}</v-icon>
          </v-btn>
        </v-col>
        <v-col sm="2" lg="2" cols="12" class="report-item__text">
          {{user.company.createdAt}}
        </v-col>
      </v-row>
    </div>

    <v-expansion-panels>
      <v-expansion-panel class="report-item report-item_mobile report-status--default">
        <v-expansion-panel-header expand-icon="mdi-menu-down">
          <v-container>
            <v-row>
              <v-col md="2" sm="12" cols="12" class="d-flex align-center ml-5 pb-0">
                <div class="report-item__text">{{user.employee.email}}</div>
              </v-col>
              <v-col md="2" sm="12" cols="12" class="d-flex align-center ml-5">
                <div class="report-item__text">{{fullName}}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container>
            <v-row>
              <v-col md="3" sm="12" cols="12" class="d-flex pb-0">
                <div class="report-item__text">{{user.company.fullName}}</div>
              </v-col>
              <v-col md="3" sm="12" cols="12" class="d-flex">
                <div class="report-item__text report-item__text_color">ИНН: {{user.company.inn}}</div>
              </v-col>
              <v-col sm="3" lg="3" cols="12" class="report-item__text report-item__last">
                <v-switch
                  v-model="status"
                  :label="user.company.status==='active' ? 'Активный' : 'Неактивный'"
                  :color="'green'"
                  :class="'switch-visible'"
                  hide-details
                  @click.stop.prevent="changeStatus"
                  inset></v-switch>
              </v-col>
              <v-col md="3" sm="12" cols="12" class="d-flex report-item__text">
                <a href="/" class="report-item__text report-item__text_color"
                   v-if="user.company.status!=='active'"
                   @click.stop.prevent="remove(user.company.id)">Удалить</a>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <a href="/" @click.stop.prevent="onClick" class="report-item__button">Подробнее</a>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {UsersElementsModel} from '@/models/admin';
  import {mdiClose, mdiWindowClose} from '@mdi/js';

  export default Vue.extend({
    components: {mdiClose, mdiWindowClose},
    props: {
      user: UsersElementsModel,
    },
    data() {
      return {
        visibility: true,
        mdiClose: mdiClose,
        mdiWindowClose: mdiWindowClose,
      };
    },
    computed: {
      fullName() {
        return `${this.user.employee.lastname} ${this.user.employee.firstname} ${this.user.employee.patronymic}`;
      },
      status() {
        return this.user.company.status === 'active' ? true : false;
      },
    },
    methods: {
      onClick() {
        this.$emit('click');
      },
      changeStatus() {
        this.$store.dispatch('commerce/updateCompanyStatus', {
          companyId: this.user.company.id,
          status: this.user.company.status === 'active' ? 'inactive' : 'active',
        }).then(() => this.$emit('refreshUser'));
      },
      remove(data) {
        this.$emit('remove', data);
      },
    },
  });
</script>
<style scoped lang="scss" src="@/styles/service/base/admin-form.scss"></style>
<style scoped lang="scss" src="@/styles/service/reports-item.scss"></style>
